// extracted by mini-css-extract-plugin
export default {"dragNDropIconContainer":"suspend-routine-styles_dragNDropIconContainer__4ze5N","badgeCustom":"suspend-routine-styles_badgeCustom__Fzytg"};